import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch from "../../Components/Common/TableContainerSearch";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";
import exportToExcel from "../../Components/Common/exportToExcel";
import { showToast } from "../../Components/ToastNotification";
import { shareEmailReportThunk } from "../../slices/thunks";
import { useDispatch } from "react-redux";
import TableContainerDateRangeFilter5 from "../../Components/Common/TableContainerDateRangeFilter5";
import CommonLoading from "../../Components/Common/CommonLoading";
import { adjustSelectedDateRange, getCurrentFiscalYearDates, getWorkingDateRange } from "../../Components/Common/WorkingDateRange";

const TransactionLedger = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  const dispatch = useDispatch();

  const token = userData?.token;
  const { startDate, endDate } = getWorkingDateRange(90);
  const [fromDate, setFromDate] = useState(startDate);
const [toDate, setToDate] = useState(endDate);


  const [dateRange, setDateRange] = useState([]);
  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  const columns = useMemo(
    () => [
      { id: "transaction_date_formatted", Header: "Trade Date", accessorKey: "transaction_date_formatted" },
      { id: "scrip_name", Header: "Particulars", accessorKey: "scrip_name",
    
    },
      {
        id: "delv_settlement_no",
        Header: "Delv. Sett. No.",
        accessorKey: "delv_settlement_no",
        headerTextAlign: "start",
        bodyTextAlign: "start",
        
      },
      {
        id: "buy_qty",
        Header: "Buy Qty.",
        accessorKey: "buy_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_qty",
        Header: "Sell Qty.",
        accessorKey: "sell_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "market_rate",
        Header: "Mkt. Rate (₹)",
        accessorKey: "market_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "net_rate",
        Header: "Net. Rate (₹)",
        accessorKey: "net_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "debit",
        Header: "Debit (₹)",
        accessorKey: "debit",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "credit",
        Header: "Credit (₹)",
        accessorKey: "credit",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "cumulative_qty",
        Header: "Cumlv. Qty.",
        accessorKey: "cumulative_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "cumulative_balance",
        Header: "Cumlv. Bal. (₹)",
        accessorKey: "cumulative_balance",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },

    
    ],
    []
  );

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };


  const handleShareEmail = async () => {
    // let startDate, endDate;
    // if (dateRange && dateRange.length === 2) {
    //   // If user has selected a custom range, adjust it to working days.
    //   const { adjustedStart, adjustedEnd } = adjustSelectedDateRange(dateRange[0], dateRange[1]);
    //   startDate = formatDate(adjustedStart);
    //   endDate = formatDate(adjustedEnd);
    // } else {
    //   const { fyStart } = getCurrentFiscalYearDates();
    //   const yesterday = new Date();
    //   yesterday.setDate(yesterday.getDate() - 1);
  
    //   startDate = formatDate(fyStart);
    //   endDate = formatDate(yesterday);
    // }

    const body = {
      report_type: "transaction-ledger",
      "additional_data[start_date]": formatDate(fromDate),
      "additional_data[end_date]": formatDate(toDate),

    };

    try {
      const response = await dispatch(
        shareEmailReportThunk({ body, token })
      ).unwrap();

      showToast("Report sent on your email successfully", "success");
    } catch (error) {
      console.error("Error submitting request:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    const fetchHoldings = async () => {
      setLoading(true);
      setError(null);
      const { startDate, endDate } = getWorkingDateRange(90);
      try {
        const response = await axios.get("transaction-ledger", {  
          params: { 
           
            start_date: formatDate(startDate),
            end_date: formatDate(endDate),
          }, 
          headers: {
            Authorization: `Bearer ${userData?.token}`, // Add Authorization header
            "Content-Type": "application/json",
          },
        });

        setSummary(response?.data?.summary);
        // console.log("here", response, response.data?.summary);
        setData(response.data?.items); // Update state with fetched data
        // setTimeout(() => {
        setLoading(false);
        // }, 2000);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        // setSummary(null)
        setError(err);
        setLoading(false);
      } finally {
        // setSummary(null)
        setLoading(false);
      }
    };

    fetchHoldings();
  }, []); // Runs when holdingType or token changes

  const handleDateRangeChange = async (values) => {
    // console.log("values",values)
    // setLoading(true);
    setError(null);
    // const holdingType = 1;
    
    try {
      const { adjustedStart, adjustedEnd } = adjustSelectedDateRange(
        values.start_date,
        values.end_date
      );
      const response = await axios.get("transaction-ledger", {
        params: 
        { start_date: values.start_date,
          end_date: values.end_date }, // Pass holdingType as query param
        headers: {
          Authorization: `Bearer ${userData?.token}`, // Add Authorization header
          "Content-Type": "application/json",
        },
      });

      // console.log("here", response);
      setSummary(response.data?.summary);
      setData(response.data?.items); // Update state with fetched data
      // setTimeout(() => {
      values.setTableLoading(false);
      // }, 2000);
    } catch (err) {
      console.error("Error fetching holdings:", err);
      // setSummary(null)
      setError(err);
      values.setTableLoading(false);
    } finally {
      values.setTableLoading(false);
      // setSummary(null)
    }
  };
 

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));

  
  


  const transactionData = Object.keys(data).reduce((acc, scripName) => {
    const rows = data[scripName];
  
    // Push each transaction row (non-group summary rows)
    rows.forEach((row) => {
      if (!row.group_summary) {
        acc.push(row);
      }
    });
  
    // Find and push the group summary row if it exists
    const groupSummary = rows.find((row) => row.group_summary);
    if (groupSummary) {
      // Create an object to structure the group summary row properly
      const summaryRow = {
        ...groupSummary.group_summary,
        scrip_name: "Scrip Total", // Column 2
        isGroupSummary: true,
      };
  
      // Ensure column 6 contains "Scrip Net"
      if (columns[5]?.accessorKey) { // Column 6 (zero-based index)
        summaryRow[columns[5].accessorKey] = "Scrip Net";
      }
  
      acc.push(summaryRow);
    }
    

    return acc;
  }, []);

  const tableBody = transactionData.map(row =>
    columns.map(col =>
      row[col.accessorKey]
        ? typeof row[col.accessorKey] === "string"
          ? row[col.accessorKey]
          : row[col.accessorKey].toLocaleString("en-IN")
        : 0
    )
  );


  

  // Define which columns to sum
  const sumColumns = ["debit", "credit", "cumulative_balance"];
  const apiTotals = {
    debit: summary?.debit, 
    credit: summary?.credit, 
    cumulative_balance: summary?.cumulative_balance,
    
  };


  // Calculate totals only for "debit" and "credit"
  const totals = columns.map((col, index) => {
    if (index === 0) return "TOTAL"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  // Add totals row to the table
  tableBody.push(totals);

  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <Card className="mb-0">
              <CardHeader>
                <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                  <h3 className="m-0">Transaction Ledger</h3>
                  <Dropdown
                    isOpen={isTopPageDropdown}
                    toggle={toggleDropdown}
                    className={`card-header-dropdown ${data?.length === 0 ? 'disabled-dropdown_export' : ''}`}
                  >
                    <DropdownToggle
                      tag="a"
                      className="text-reset dropdown-btn"
                      role="button"
                      color="success"
                    >
                      <Button type="button" color="success">
                        Export<i className="ms-1 bx bx-caret-down"></i>
                      </Button>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          exportToPDF(
                            "Transaction Ledger",
                            userData,
                            "",
                            `From: ${summary?.start} - To: ${summary?.end}`,
                            tableHeaders,
                            tableBody
                          )
                        }
                      >
                        Export as PDF
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          exportToExcel(
                            "Transaction Ledger",
                            userData,
                            "",
                            `From: ${summary?.start} - To: ${summary?.end}`,
                            tableHeaders,
                            tableBody,
                            "",
                            [],
                            []
                          )
                        }
                      >
                        Export Excel
                      </DropdownItem>
                      <DropdownItem
                      onClick={handleShareEmail}
                      >Share on Email</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </CardHeader>
              <CardBody>
                <TableContainerDateRangeFilter5
                   footer={true}
                  //  type="FO"
                   summary={summary}
                   columns={columns}
                   data={data}
                   onDateRangeChange={handleDateRangeChange}
                   dateRange={dateRange}
                   setDateRange = {setDateRange}
                   transactionData= {transactionData}
                   fromDate={fromDate}
                   setFromDate={setFromDate}
                   toDate={toDate}
                   setToDate={setToDate}
                />
              </CardBody>
            </Card>
          )}
          {/* <BreadCrumb title="Dashboard" pageTitle="Dashboards" /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TransactionLedger;
